/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Nodocuments2Inputs */

const en_coinvestments_nrl_nodocuments2 = /** @type {(inputs: Coinvestments_Nrl_Nodocuments2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents available to track`)
};

/**
* | output |
* | --- |
* | "No documents available to track" |
*
* @param {Coinvestments_Nrl_Nodocuments2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_nodocuments2 = /** @type {((inputs?: Coinvestments_Nrl_Nodocuments2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Nodocuments2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_nodocuments2(inputs)
});
export { coinvestments_nrl_nodocuments2 as "coInvestments_nrl_noDocuments" }